import Intents from '@ux/intents';
const intents = new Intents();
import { getIntents } from '../utils/intents';

const themeColors = {
  'white': intents.ux.boxHighContrast.foregroundColor,
  'black': intents.ux.box.foregroundColor,
  'gray': intents.ux.feedbackHighContrastPassive.feedbackColor,
  'product': intents.ux.feedbackHighContrastPassive.feedbackColor,
  'primary': intents.ux.feedback.feedbackColor,
  'primary-o': intents.ux.feedbackHighContrastHighlight.feedbackColor,
  'success': intents.ux.feedbackSuccess.feedbackColor,
  'secondary': intents.ux.feedbackNeutral.feedbackColor,
  'secondary-o': intents.ux.feedbackNeutral.feedbackColor,
  'nav': intents.ux.feedbackWarning.feedbackColor,
  'info': intents.ux.feedbackInfo.feedbackColor,
  'warning': intents.ux.feedbackWarning.feedbackColor,
  'danger': intents.ux.feedbackHighContrastCritical.feedbackColor,
  'feature': intents.ux.feedbackInternal.feedbackColor,
  'muted': intents.ux.feedbackHighContrastPassive.feedbackColor
};

export default ({ color }) => {
  const intentColor = themeColors?.[color] || getIntents(color);
  return (color && typeof color  === 'string') ? { color: intentColor } : null;
};
